const promiseTimeout = function (
  ms: number,
  promise: Promise<any>
): Promise<any> {
  // Create a promise that rejects in <ms> milliseconds
  const timeout: Promise<any> = new Promise(
    (resolve: Function, reject: Function) => {
      const id = setTimeout(() => {
        clearTimeout(id)
        reject("Timed out in " + ms + "ms.")
      }, ms)
    }
  )

  // Returns a race between our timeout and the passed in promise
  return Promise.race([promise, timeout])
}

export default promiseTimeout
